"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginRedirect = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
exports.LoginRedirect = function () {
    var search = new URLSearchParams(window.location.search);
    var tokenParameter = search.get("token");
    var token = tokenParameter ? window.atob(tokenParameter) : "";
    var data = window.localStorage.getItem("data");
    var dataValue = data ? JSON.parse(window.atob(data)) : null;
    var ancora = dataValue['ancora'];
    window.localStorage.setItem("token", token);
    return React.createElement(react_router_dom_1.Redirect, { to: "/meeting-queue-auth/" + ancora + "?data=" + data });
};
//# sourceMappingURL=login-redirect.js.map